import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import Select from 'react-select';
import { ADDED_BY_ID } from "../../../Constants";
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { useDispatch, useSelector } from "react-redux";
import { loadContainerTypeProductCategoryDropdownData, loadContainerTypeRtmsCategoryDropdownData, postLogisticsContainerTypeDatas } from "../../../redux/action";

const statusOptions = [
    { value: 109, label: "Active" },
    { value: 110, label: "Inactive" }
]

const AddContainerType = (props) => {

    let dispatch = useDispatch();
    const { productCategoryDropdownData, rtmsCategoryDropdownData } = useSelector((state) => state.data);

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedCompanyID = signInDetails ? signInDetails[0].CompanyID : null;

    const singleLogisticsContainerTypeData = props.singleLogisticsContainerTypeData;
    const containerTypeID = props.containerTypeID;
    const containerTypeData = props.containerTypeData;

    const [logisticsContainerTypeData, setLogisticsContainerTypeData] = useState({
        UnitCode: "",
        Description: "",
        Length: null,
        Width: null,
        Height: null,
        TareWeight: null,
        Payload: null,
        RTMSCategoryID: null,
        ProductCategoryID: null,
        CompanyID: storedCompanyID,
        AddedByID: ADDED_BY_ID,
        StatusID: null
    })

    const [errors, setErrors] = useState({});

    useEffect(() => {
        dispatch(loadContainerTypeRtmsCategoryDropdownData());
        dispatch(loadContainerTypeProductCategoryDropdownData());
    }, [])

    useEffect(() => {
        if (containerTypeID && singleLogisticsContainerTypeData?.length > 0) {
            const containerTypeData = singleLogisticsContainerTypeData[0];
            setLogisticsContainerTypeData({
                ContainerTypeID: containerTypeID,
                UnitCode: containerTypeData.UnitCode || "",
                Description: containerTypeData.Description || "",
                Length: containerTypeData.Length || "",
                Width: containerTypeData.Width || "",
                Height: containerTypeData.Height || "",
                TareWeight: containerTypeData.TareWeight || "",
                Payload: containerTypeData.Payload || "",
                RTMSCategoryID: { value: containerTypeData.RTMSCategoryIDFK, label: containerTypeData.RTMSCategoryType },
                ProductCategoryID: { value: containerTypeData.ProductCategoryIDFK, label: containerTypeData.ProductCategory },
                StatusID: { value: containerTypeData.StatusID, label: containerTypeData.Status },
                CompanyID: containerTypeData.CompanyID,
                AddedByID: ADDED_BY_ID
            });
        }
    }, [containerTypeID, singleLogisticsContainerTypeData]);

    const handleChange = (field, value) => {
        setLogisticsContainerTypeData(prevState => ({ ...prevState, [field]: value }));
        if (errors[field]) {
            setErrors(prevErrors => ({ ...prevErrors, [field]: value ? "" : `required !` }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        ['UnitCode', 'Description', 'Length', 'Width', 'Height', 'TareWeight', 'Payload', 'RTMSCategoryID', 'ProductCategoryID'].forEach(field => {
            if (!logisticsContainerTypeData[field]) newErrors[field] = `required !`;
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const AddLogisticsContainerTypeData = (e) => {
        e.preventDefault();
        if (validateForm()) {
            const formData = {
                ...logisticsContainerTypeData,
                RTMSCategoryID: logisticsContainerTypeData.RTMSCategoryID?.value,
                ProductCategoryID: logisticsContainerTypeData.ProductCategoryID?.value,
                StatusID: logisticsContainerTypeData.StatusID?.value
            };
            let requestOption = {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.postExcomatixAuth,
                body: JSON.stringify(formData),
            };
            dispatch(postLogisticsContainerTypeDatas(requestOption, props.handleCloseModal, containerTypeID, containerTypeData));
            console.log(formData, 'ZoneMasterData')
        }
    };

    return (
        <>
            <Modal show={props.open} onHide={props.handleCloseModal} className='add-customer-modal add-role-modal' centered>
                <Modal.Header closeButton>
                    <Modal.Title>{containerTypeID ? "Edit Container Type" : "Add Container Type"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Unit Code <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            value={logisticsContainerTypeData.UnitCode}
                                            onChange={(e) => handleChange('UnitCode', e.target.value)}
                                        />
                                    </div>
                                    {errors.UnitCode && <div className="text-danger">{errors.UnitCode}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Description <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            value={logisticsContainerTypeData.Description}
                                            onChange={(e) => handleChange('Description', e.target.value)}
                                        />
                                    </div>
                                    {errors.Description && <div className="text-danger">{errors.Description}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Length <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            value={logisticsContainerTypeData.Length}
                                            onChange={(e) => handleChange('Length', e.target.value)}
                                        />
                                    </div>
                                    {errors.Length && <div className="text-danger">{errors.Length}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Width <span className="required-asterisk">*</span> </label>
                                        <Form.Control
                                            type="text"
                                            value={logisticsContainerTypeData.Width}
                                            onChange={(e) => handleChange('Width', e.target.value)}
                                        />
                                    </div>
                                    {errors.Width && <div className="text-danger">{errors.Width}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Height <span className="required-asterisk">*</span> </label>
                                        <Form.Control
                                            type="text"
                                            value={logisticsContainerTypeData.Height}
                                            onChange={(e) => handleChange('Height', e.target.value)}
                                        />
                                    </div>
                                    {errors.Height && <div className="text-danger">{errors.Height}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Tare <span className="required-asterisk">*</span> </label>
                                        <Form.Control
                                            type="text"
                                            value={logisticsContainerTypeData.TareWeight}
                                            onChange={(e) => handleChange('TareWeight', e.target.value)}
                                        />
                                    </div>
                                    {errors.TareWeight && <div className="text-danger">{errors.TareWeight}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Payload <span className="required-asterisk">*</span> </label>
                                        <Form.Control
                                            type="text"
                                            value={logisticsContainerTypeData.Payload}
                                            onChange={(e) => handleChange('Payload', e.target.value)}
                                        />
                                    </div>
                                    {errors.Payload && <div className="text-danger">{errors.Payload}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>RTMS Category <span className="required-asterisk">*</span> </label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={rtmsCategoryDropdownData}
                                            placeholder="Select"
                                            value={logisticsContainerTypeData.RTMSCategoryID}
                                            onChange={(value) => handleChange('RTMSCategoryID', value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                    {errors.RTMSCategoryID && <div className="text-danger">{errors.RTMSCategoryID}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Product Category <span className="required-asterisk">*</span> </label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={productCategoryDropdownData}
                                            placeholder="Select"
                                            value={logisticsContainerTypeData.ProductCategoryID}
                                            onChange={(value) => handleChange('ProductCategoryID', value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                    {errors.ProductCategoryID && <div className="text-danger">{errors.ProductCategoryID}</div>}
                                </Col>
                            </Row>
                            <Row>
                                {containerTypeID && <Col md={4}>
                                    <div>
                                        <label>Status <span className="required-asterisk">*</span> </label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={statusOptions}
                                            placeholder="Select"
                                            value={logisticsContainerTypeData.StatusID}
                                            onChange={(value) => handleChange('StatusID', value)}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>}
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                    <SBSaveUpdateBtn btnName="Submit" onClickEffect={AddLogisticsContainerTypeData} />
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddContainerType;
